import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'next/image';
import homeIcon from '@/public/images/icons/home.svg';
import arrowRightIcon from '@/public/images/icons/arrow_right.svg';
import Link from 'next/link';
import { SkuBreadcrumbsProps } from '@/types/props/components/skus';
import {
  createCountyOfOriginUrl,
  createCategoryUrl,
} from '@/utilites/algolia/create-algolia-urls';
import ConditionalLink from './common/ConditionalLink';
import isStringNotDefined from '@/utilites/is-string-not-defined';

const SkuBreadcrumbs = ({
  skuCategoryName,
  skuCountryOfOrigin,
  skuName,
}: SkuBreadcrumbsProps) => {
  return (
    <Row className="align-items-center py-2 g-0">
      <Col className="col-auto tw-flex tw-items-center tw-justify-center">
        <Link href={`/search`} className={`tw-flex`}>
          <Image
            src={homeIcon}
            width={15}
            height={15}
            alt="Home"
            className="me-2"
          />
        </Link>
        <Image
          src={arrowRightIcon}
          width={4}
          height={9}
          alt="Arrow right"
          className="me-2"
        />
      </Col>
      <Col className="col-auto">
        <span className="font-size-13 text-secondary me-1">
          <ConditionalLink
            aria-label={`Go to ${skuCategoryName} category`}
            disabled={isStringNotDefined(skuCategoryName)}
            className="text-breadcrumbs-inactive"
            href={createCategoryUrl(String(skuCategoryName))}
          >
            {skuCategoryName && skuCategoryName}
          </ConditionalLink>
        </span>
        <Image
          src={arrowRightIcon}
          width={4}
          height={9}
          alt="Arrow right"
          className="me-2"
        />
      </Col>
      <Col className="col-auto">
        <span className="font-size-13 text-secondary me-1">
          <ConditionalLink
            aria-label={`Go to ${skuCountryOfOrigin} brand`}
            disabled={isStringNotDefined(skuCountryOfOrigin)}
            className="text-breadcrumbs-inactive"
            href={createCountyOfOriginUrl(String(skuCountryOfOrigin))}
          >
            {skuCountryOfOrigin && skuCountryOfOrigin}
          </ConditionalLink>
        </span>
        <Image
          src={arrowRightIcon}
          width={4}
          height={9}
          alt="Arrow right"
          className="me-2"
        />
      </Col>
      <Col>
        <span className="font-size-13 text-breadcrumbs-active me-1 limit-1-lines">
          {' '}
          {skuName && skuName}{' '}
        </span>
      </Col>
    </Row>
  );
};

export default SkuBreadcrumbs;
